import React from 'react'
import { Skill } from '../component/Skill'
import { Footer } from '../layout/Footer'
import { Navigationbar } from '../layout/Navigationbar'

export const Skillpage = () => {
  return (
    <div>
        <Navigationbar/>
        <Skill/>
        <Footer/>
    </div>
  )
}
